import { Host, h } from "@stencil/core";
import state from "../store";
export class GxgFormMessage {
    constructor() {
        this.type = "indeterminate";
    }
    iconType() {
        if (this.type === "error") {
            return "gemini-tools/error";
        }
        else if (this.type === "warning") {
            return "gemini-tools/warning";
        }
        else if (this.type === "success") {
            return "gemini-tools/success";
        }
    }
    iconColor = () => {
        if (this.type === "warning" ||
            this.type === "error" ||
            this.type === "success") {
            return this.type;
        }
        else {
            return "auto";
        }
    };
    render() {
        return (h(Host, { class: {
                large: state.large,
            } }, this.type !== "indeterminate" ? (h("gxg-icon", { style: { "--icon-size": "15px" }, slot: "icon", size: "small", type: this.iconType(), color: this.iconColor() })) : null, h("slot", null)));
    }
    static get is() { return "gxg-form-message"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["form-message.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["form-message.css"]
        };
    }
    static get properties() {
        return {
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "Message",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "Message": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-message/form-message.tsx",
                            "id": "src/components/form-message/form-message.tsx::Message"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The type of message"
                },
                "attribute": "type",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            }
        };
    }
}
//# sourceMappingURL=form-message.js.map
